module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABaElEQVRYhcVXW47EIAxzVnMvOBpHc0+W/ShUkOG1A8xaqqAVISZO0hb4ZwgAqOp4oYjGtbIyN3vOERARVVWI3PYr85yIiOBn6uRpA1WQhIiAJP78PIQimjmj5gVASSpU18YQNO0V4nxIYJtz1c8J7HZuCbxG2vO64J27R+8BAD6uaY7WrpNj3SQsNnHuSbDhmNvF5CNZ9VGNgIgoycI5RMYnB/Bm13Bc4LT2IYTnGibhLue29EiqxudDAiectwgUOVDT/tMxaZ8nH8mnkqo5sFt7e/quBCe17xEoJFgNe173wdR+mlcl2JZ4g/A3JTip/YiAPATiu3oZMfwteO9BMq2RF1B+Nq3C9nznXHF/XVdx/yShmu+1HKk/nEDzdWzxKQFrZ6tgmkCrfHqw4QfeJRh+lJ7GUQlqNl+RoBb6hGYVrGw6C+t8mkDqEztK0e4x/W8I3P2g1+VmEUJIh5qXANjXMXtN7+v4BdJQg3+vviKoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/NOTEPAD_32.png
// module id = 89
// module chunks = 0